<template>
  <div>
    <div class="intelligentBox box-shadow" v-show="!showEffectAnalysisX">
      <div class="global-title">智能营销</div>
      <!-- tab切换栏 -->
      <div class="tab-line">
        <div class="tab-item" @click="handleSwitch(1)" :class="{ active: tabIndex == '1' }" :style="{
          color: tabIndex == '1' ? globalBG : '',
          'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
        }">
          智能营销
          <span></span>
        </div>
        <div class="tab-item" @click="handleSwitch(2)" :class="{ active: tabIndex == '2' }" :style="{
          color: tabIndex == '2' ? globalBG : '',
          'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
        }">
          短信记录
          <span></span>
        </div>
        <div class="tab-item" @click="handleSwitch(3)" :class="{ active: tabIndex == '3' }" :style="{
          color: tabIndex == '3' ? globalBG : '',
          'border-top': tabIndex == '3' ? '2px solid ' + globalBG : '',
        }">
          营销效果
          <span></span>
        </div>
      </div>
      <!-- 推荐模板 -->
      <div class="recom-template" v-if="tabIndex == 1">
        <div class="recom-title">
          <span class="divison"></span>
          <span class="name">推荐模板</span>
          <span class="open" @click="isShowAll = !isShowAll">{{
            isShowAll ? "收起" : "展开"
          }}</span>
        </div>
        <div class="recom-list" :style="{ 'max-height': isShowAll ? '100%' : '174px' }">
          <div class="recom-item" v-for="(item, index) in recommondList" :key="index">
            <div class="recom-content">
              <div class="img-wrap">
                <img v-if="item.iconUrl" :src="item.iconUrl" alt="" />
                <img v-else src="@/assets/images/recom_default.png" alt="" />
              </div>
              <div class="text-info">
                <p class="title">{{ item.name }}</p>
                <p class="info">{{ item.description }}</p>
              </div>
            </div>
            <div class="create-btn" @click="newBtn(index)">立即创建</div>
          </div>
        </div>
      </div>
      <!-- 短信记录 -->
      <sms-record-form v-if="tabIndex == '2'" :searchform="searchform"></sms-record-form>
      <!-- 营销效果 -->
      <effect-market-form @showEffect="showEffectX" v-if="tabIndex == '3'"
        :searchform="searchform"></effect-market-form>

      <!-- 智能营销 -->
      <div v-if="tabIndex == '1'" style="margin-top: 10px">
        <!-- 查询 -->
        <div class="search-box">
          <el-form ref="formSearch" :inline="true" :model="queryForm" label-width="120px">
            <el-form-item label="活动名称:">
              <el-input size="small" v-model="queryForm.activityName" placeholder="请输入活动主题"></el-input>
            </el-form-item>
            <el-form-item label="活动状态:">
              <el-select size="small" v-model="queryForm.webActivityStatus">
                <el-option v-for="item in statuss" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="执行方式:">
              <el-select size="small" v-model="queryForm.executionType">
                <el-option value="" label="全部" />
                <el-option :value="0" label="立即执行" />
                <el-option :value="1" label="定时执行" />
                <el-option :value="2" label="周期执行" />
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间:">
              <div class="my_select_time">
                <el-date-picker prefix-icon="no_icon" v-model="queryForm.createTimeStart" type="datetime"
                  :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker prefix-icon="no_icon" v-model="queryForm.createTimeEnd" type="datetime"
                  :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px" class="time2" :clearable="false"></el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTime1()"></i>
                <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
              </div>
            </el-form-item>
          </el-form>
          <div class="el_btn">
            <el-button size="small" :disabled="tableLoading" class="search" @click="handleSearch">
              <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
              查询
            </el-button>
            <el-button size="small" class="reset" @click="resetForm">重置</el-button>
          </div>
        </div>
        <div class="tab_item_box">
          <div>
            <span class="create_btn3" @click="createActivity">
              <img src="@/assets/images/member/new_establish.png" style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px -6px 0px 12px;
                " />
              新建活动
            </span>
            <span style="cursor: pointer; margin-left: 24px; font-size: 15px" @click="dialogTemplateVisible = true">
              <i style="font-size: 16px" class="el-icon-menu"></i>
              <span> 模板库</span>
            </span>
            <div class="right_allBtn">
              <!-- 活动名称:
              <el-input
                v-model="queryForm.activityName"
                placeholder="请输入任务名称"
                style="width: 280px; margin: 0 5px 0 8px"
              ></el-input>
              <el-button
                icon="el-icon-search"
                class="status_btn"
                :disabled="tableLoading"
                @click="handleSearch"
                >查询</el-button
              > -->
              <!-- <el-button class="status_btn status_btn2" @click="resetBtn1"
                >重置</el-button
              > -->
            </div>
          </div>
        </div>
        <!-- 旧需求 -->
        <!-- <div class="tab_item_box_one">
          <el-tabs v-model="activeStatus" @tab-click="handleClick">
            <el-tab-pane label="全部" name="-1"></el-tab-pane>
            <el-tab-pane label="设计中" name="0"></el-tab-pane>
            <el-tab-pane label="执行中" name="1"></el-tab-pane>
            <el-tab-pane label="已结束" name="2"></el-tab-pane>
          </el-tabs>
        </div> -->

        <!-- 表格内容 -->
        <div class="table-center">
          <el-table :data="tableData" v-loading="tableLoading" style="width: 100%"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }">
            <el-table-column label="活动ID" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="活动名称">
              <template slot-scope="scope">
                <span>{{ scope.row.activityName }}</span><i class="el-icon-edit-outline"
                  @click="handleName(scope.$index, scope.row)"></i>
              </template>
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="执行方式">
              <template slot-scope="scope">
                <span v-if="scope.row.executionType == 0">立即执行</span>
                <span v-else>{{
                  scope.row.executionType | showExecution
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="启动时间">
              <template slot-scope="scope">
                <span>{{ scope.row.startUpTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="执行时间">
              <template slot-scope="scope">
                <div v-if="scope.row.executionType === 2">
                  <p>上次 {{ scope.row.executionDate || "--" }}</p>
                  <p>下次 {{ scope.row.nextExecutionDate || "--" }}</p>
                </div>
                <div v-else>
                  {{ scope.row.executionDate || "--" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="活动状态">
              <!-- <el-table-column>
              <template slot="header" slot-scope="scope">
                <el-select v-model="activeStatus" @change="statusChange" placeholder="全部">
                  <el-option
                    v-for="item in statuss"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template> -->
              <template slot-scope="scope">
                <span>{{ scope.row.activityStatus | showStatus }}</span>
                <el-tooltip v-if="scope.row.activityStatus == 7" placement="top">
                  <div slot="content" v-html="'活动节点出现异常，可进入画布进行查看'"></div>
                  <span><i class="el-icon-warning"></i></span>
                </el-tooltip>
                <el-tooltip v-else-if="scope.row.cycleExecutionDatetimeList" placement="top">
                  <div slot="content" v-html="scope.row.cycleExecutionDatetimeList.join('，')"></div>
                  <span><i class="el-icon-warning"></i></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="预计触达人数">
              <template slot="header" slot-scope="scope">
                <div>
                  预计触达人数
                  <el-tooltip class="item" effect="dark" content="预计触达人数在测试执行后更新，实际触达人数以短信记录为准。" placement="top-start">
                    <i class="el-icon-question tips" :style="{ color: '#CCCCCC' }"></i>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div v-if="
                  scope.row.sendSmsMemNum ||
                  scope.row.sendMediaMemNum ||
                  scope.row.sendCardMemNum ||
                  scope.row.sendDongdongMemNum
                ">
                  <div>
                    短信：{{
                      scope.row.sendSmsMemNum !== undefined &&
                        scope.row.sendSmsMemNum !== null
                        ? scope.row.sendSmsMemNum
                        : "-"
                    }}
                  </div>
                  <div>
                    富信：{{
                      scope.row.sendMediaMemNum !== undefined &&
                        scope.row.sendMediaMemNum !== null
                        ? scope.row.sendMediaMemNum
                        : "-"
                    }}
                  </div>
                  <div>
                    卡片短信：{{
                      scope.row.sendCardMemNum !== undefined &&
                        scope.row.sendCardMemNum !== null
                        ? scope.row.sendCardMemNum
                        : "-"
                    }}
                  </div>
                  <div>
                    咚咚消息：{{
                      scope.row.sendDongdongMemNum !== undefined &&
                        scope.row.sendDongdongMemNum !== null
                        ? scope.row.sendDongdongMemNum
                        : "-"
                    }}
                  </div>
                </div>
                <div v-else>
                  {{ "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="实际触达人数">
              <template slot="header" slot-scope="scope">
                <div>
                  实际触达人数
                  <el-tooltip class="item" effect="dark" content="活动正式执行发送后显示实际触达人数，如活动为周期执行，则显示最后一次正式执行的人数"
                    placement="top-start">
                    <i class="el-icon-question tips" :style="{ color: '#CCCCCC' }"></i>
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div v-if="
                  scope.row.actSmsMemNum ||
                  scope.row.actMediaMemNum ||
                  scope.row.actCardMemNum ||
                  scope.row.actDongdongMemNum
                ">
                  <div>
                    短信：{{
                      scope.row.actSmsMemNum !== undefined &&
                        scope.row.actSmsMemNum !== null
                        ? scope.row.actSmsMemNum
                        : "-"
                    }}
                  </div>
                  <div>
                    富信：{{
                      scope.row.actMediaMemNum !== undefined &&
                        scope.row.actMediaMemNum !== null
                        ? scope.row.actMediaMemNum
                        : "-"
                    }}
                  </div>
                  <div>
                    卡片短信：{{
                      scope.row.actCardMemNum !== undefined &&
                        scope.row.actCardMemNum !== null
                        ? scope.row.actCardMemNum
                        : "-"
                    }}
                  </div>
                  <div>
                    咚咚消息：{{
                      scope.row.actDongdongMemNum !== undefined &&
                        scope.row.actDongdongMemNum !== null
                        ? scope.row.actDongdongMemNum
                        : "-"
                    }}
                  </div>
                </div>
                <div v-else>
                  {{ "-" }}
                </div>
              </template>
            </el-table-column>
            <!-- 旧版UI -->
            <!-- <el-table-column label="操作" width="350">
              <template slot-scope="scope">
                <template>
                  <el-button
                    size="small"
                    type="text"
                    v-if="scope.row.topSort == 0 && showTop"
                    class="operation"
                    @click="handleView1(1, scope.row)"
                    >置顶</el-button
                  >
                  <el-button
                    v-if="scope.row.topSort > 0"
                    size="small"
                    type="text"
                    class="operation"
                    @click="handleView1(0, scope.row)"
                    >取消置顶</el-button
                  >
                  <el-button
                    size="small"
                    :style="
                      scope.row.isHaveBenefitNode ||
                      scope.row.isHaveYunQiTypeNode
                        ? 'color:#999999;width: 40px;margin-left: -10px;'
                        : 'width: 40px;margin-left: -10px;'
                    "
                    type="text"
                    class="operation"
                    :disabled="
                      scope.row.isHaveBenefitNode ||
                      scope.row.isHaveYunQiTypeNode
                    "
                    @click="handleView(scope.$index, scope.row)"
                    >{{
                      scope.row.activityStatus == 0 ? "设计" : "查看"
                    }}</el-button
                  >
                  <el-button
                    size="small"
                    type="text"
                    :style="
                      scope.row.isHaveBenefitNode ||
                      scope.row.isHaveYunQiTypeNode
                        ? 'color:#999999;width: 40px'
                        : 'width: 40px'
                    "
                    class="operation"
                    :disabled="
                      scope.row.isHaveBenefitNode ||
                      scope.row.isHaveYunQiTypeNode
                    "
                    @click="handleCopy(scope.$index, scope.row)"
                    >复制</el-button
                  >
                  <el-dropdown>
                    <div
                      class="operation"
                      style="margin-left: 20px"
                      type="blueText"
                    >
                      更多
                    </div>
                    <el-dropdown-menu slot="dropdown" style="width: 110px">
                      <el-dropdown-item>
                        <el-button
                          size="small"
                          type="text"
                          :style="
                            scope.row.isHaveBenefitNode ||
                            scope.row.isHaveYunQiTypeNode
                              ? 'color:#999999;width: 40px'
                              : 'width: 40px'
                          "
                          class="operation"
                          :disabled="
                            scope.row.isHaveBenefitNode ||
                            scope.row.isHaveYunQiTypeNode
                          "
                          @click="handleSaveAs(scope.$index, scope.row)"
                          >另存</el-button
                        >
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          size="small"
                          type="text"
                          style="width: 60px"
                          class="operation"
                          @click="toTab(scope.$index, scope.row, 2)"
                          v-if="
                            (scope.row.activityStatus == 2 ||
                              scope.row.activityStatus == 5 ||
                              scope.row.activityStatus == 6 ||
                              scope.row.activityStatus == 1 ||
                              scope.row.activityStatus == 8 ||
                              scope.row.activityStatus == 7) &&
                            scope.row.isHaveSmsRecord
                          "
                          >短信记录</el-button
                        >
                      </el-dropdown-item>

                      <el-dropdown-item>
                        <el-button
                          size="small"
                          type="text"
                          style="width: 40px"
                          class="operation"
                          @click="toTab(scope.$index, scope.row, 3)"
                          v-if="
                            (scope.row.activityStatus == 2 ||
                              scope.row.activityStatus == 5 ||
                              scope.row.activityStatus == 6 ||
                              scope.row.activityStatus == 1 ||
                              scope.row.activityStatus == 8 ||
                              scope.row.activityStatus == 7) &&
                            scope.row.sendNum
                          "
                          >营销效果</el-button
                        >
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          size="small"
                          type="text"
                          style="width: 40px"
                          @click="handleStop(scope.$index, scope.row)"
                          v-if="
                            scope.row.activityStatus == 5 ||
                            scope.row.activityStatus == 6
                          "
                          >终止</el-button
                        >
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          size="small"
                          style="width: 40px"
                          type="text"
                          @click="handleDelete(scope.$index, scope.row)"
                          v-if="scope.row.activityStatus == 0"
                          >删除</el-button
                        >
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          size="small"
                          type="text"
                          style="width: 40px; color: #715dff"
                          @click="handleSuspend(scope.$index, scope.row)"
                          v-if="
                            scope.row.activityStatus == 5 ||
                            scope.row.activityStatus == 6
                          "
                          >暂停</el-button
                        >
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          size="small"
                          type="text"
                          style="width: 40px; color: #715dff"
                          @click="handleStartUp(scope.$index, scope.row)"
                          v-if="scope.row.activityStatus == 9"
                          >启动</el-button
                        >
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </template>
            </el-table-column> -->
            <!-- 新版UI -->
            <el-table-column label="操作" width="350">
              <template slot-scope="scope">
                <template>
                  <div class="btnGroup" style="justify-content: left" :class="getBtnWidth ? 'btnGroup-width' : ''">
                    <jd-button type="blueText" @click="handleView1(1, scope.row)"
                      v-if="scope.row.topSort == 0 && showTop">置顶</jd-button>
                    <jd-button type="blueText" v-if="scope.row.topSort > 0"
                      @click="handleView1(0, scope.row)">取消置顶</jd-button>
                    <jd-button type="blueText" @click="handleView(scope.$index, scope.row)">{{
                      scope.row.activityStatus == 0 ? "设计" : "查看"
                    }}</jd-button>
                    <jd-button type="blueText" @click="toTab(scope.$index, scope.row, 2)" :disabled="!(
                      (scope.row.activityStatus == 2 ||
                        scope.row.activityStatus == 5 ||
                        scope.row.activityStatus == 6 ||
                        scope.row.activityStatus == 1 ||
                        scope.row.activityStatus == 8 ||
                        scope.row.activityStatus == 7) &&
                      scope.row.isHaveSmsRecord
                    )
                      ">短信记录</jd-button>
                    <el-dropdown class="more">
                      <div class="btnText" style="color: #2768ff; margin-left: 12px" type="blueText">
                        更多
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :disabled="!(
                          (scope.row.activityStatus == 2 ||
                            scope.row.activityStatus == 5 ||
                            scope.row.activityStatus == 6 ||
                            scope.row.activityStatus == 1 ||
                            scope.row.activityStatus == 8 ||
                            scope.row.activityStatus == 7) &&
                          scope.row.sendNum
                        )
                          ">
                          <jd-button type="blueText" :disabled="!(
                            (scope.row.activityStatus == 2 ||
                              scope.row.activityStatus == 5 ||
                              scope.row.activityStatus == 6 ||
                              scope.row.activityStatus == 1 ||
                              scope.row.activityStatus == 8 ||
                              scope.row.activityStatus == 7) &&
                            scope.row.sendNum
                          )
                            " @click="toTab(scope.$index, scope.row, 3)">营销效果</jd-button>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <jd-button type="blueText" v-if="
                            scope.row.activityStatus == 5 ||
                            scope.row.activityStatus == 6
                          " @click="handleSuspend(scope.$index, scope.row)">暂停</jd-button>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <jd-button type="blueText" v-if="scope.row.activityStatus == 9"
                            @click="handleStartUp(scope.$index, scope.row)">启动</jd-button>
                        </el-dropdown-item>
                        <el-dropdown-item :disabled="scope.row.isHaveBenefitNode ||
                          scope.row.isHaveYunQiTypeNode
                          ">
                          <jd-button type="blueText" @click="handleCopy(scope.$index, scope.row)" :disabled="scope.row.isHaveBenefitNode ||
                            scope.row.isHaveYunQiTypeNode
                            ">复制</jd-button>
                        </el-dropdown-item>
                        <el-dropdown-item :disabled="scope.row.isHaveBenefitNode ||
                          scope.row.isHaveYunQiTypeNode
                          ">
                          <jd-button type="blueText" @click="handleSaveAs(scope.$index, scope.row)" :disabled="scope.row.isHaveBenefitNode ||
                            scope.row.isHaveYunQiTypeNode
                            ">另存</jd-button>
                        </el-dropdown-item>
                        <el-dropdown-item :disabled="!(
                          scope.row.activityStatus == 5 ||
                          scope.row.activityStatus == 6
                        )
                          ">
                          <jd-button type="blueText" @click="handleStop(scope.$index, scope.row)" :disabled="!(
                            scope.row.activityStatus == 5 ||
                            scope.row.activityStatus == 6
                          )
                            ">终止</jd-button>
                        </el-dropdown-item>
                        <el-dropdown-item :disabled="!(scope.row.activityStatus == 0)">
                          <jd-button type="blueText" @click="handleDelete(scope.$index, scope.row)"
                            :disabled="!(scope.row.activityStatus == 0)">删除</jd-button>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background style="text-align: right; margin: 20px -10px 0px 0px" small
            layout="total, prev, pager, next" :current-page.sync="queryForm.current" :page-size="queryForm.pageSize"
            :total="queryForm.total" @current-change="queryCurrentChange">
          </el-pagination>
          <!-- 新建活动 -->
          <el-dialog title="新建活动" :visible.sync="dialogCampaignVisible" :close-on-click-modal="false"
            :append-to-body="false" @close="newFormClose">
            <el-form :model="formCampaign" ref="formCampaign" :rules="rules">
              <el-form-item label="活动名称" prop="activityName" :label-width="formLabelWidth">
                <el-input v-model="formCampaign.activityName" autocomplete="off" maxlength="20">
                  <span slot="suffix" style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    ">{{ formCampaign.activityName.length }}/20</span>
                </el-input>
              </el-form-item>
              <el-form-item label="活动模板" :label-width="formLabelWidth">
                <div style="text-align: left">
                  <el-radio-group v-model="formCampaign.templateType" @change="typeTemplateChange">
                    <el-radio label="">空白模板</el-radio>
                    <el-radio :label="1">系统模板</el-radio>
                    <el-radio :label="2">自定义模板</el-radio>
                  </el-radio-group>
                </div>
                <div style="text-align: left; margin-top: 8px">
                  <div v-if="templateList.length" class="templist" v-loading="tempLoading" element-loading-text="模板加载中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="titem" v-for="(item, index) in templateList" :key="item.value"
                      @click.stop="selectTemplate(index)" :class="{ active: item.selected }"
                      :style="{ background: item.selected ? globalBG : '' }">
                      <span>{{ item.name }}</span>
                      <el-button v-show="formCampaign.templateType === 2" type="text"
                        @click.stop="deleteItem(index, item.id)" icon="el-icon-delete" circle></el-button>
                    </div>
                  </div>
                  <div v-else-if="!tempLoading" style="color: red">
                    {{
                      formCampaign.templateType === 2 ? "没有自定义模板" : ""
                    }}
                    {{ formCampaign.templateType === 1 ? "没有系统模板" : "" }}
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 0">
              <el-button @click="dialogCampaignVisible = false">取 消</el-button>
              <el-button type="primary" @click="addCampaign">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 活动名称修改 -->
          <el-dialog title="修改活动名称" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
            <el-form :model="formName" :rules="rules" ref="formName">
              <el-form-item label="活动名称" prop="activityName" :label-width="formLabelWidth">
                <el-input v-model="formName.activityName" autocomplete="off" maxlength="20">
                  <span slot="suffix" style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    ">{{ formName.activityName.length }}/20</span>
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="updateName">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 另存为模板 -->
          <el-dialog title="另存为模板" :visible.sync="dialogTemplateFormVisible" :close-on-click-modal="false">
            <el-form :model="formTemplate" :rules="rulest" ref="formTemplate">
              <el-form-item label="模板名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="formTemplate.name" autocomplete="off" maxlength="20">
                  <span slot="suffix" style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    ">{{ formTemplate.name.length }}/20</span>
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogTemplateFormVisible = false">取 消</el-button>
              <el-button type="primary" v-loading="saveTemplateLoading" :disabled="saveTemplateLoading"
                @click="saveAsTemplate" v-preventReClick>确 定</el-button>
            </div>
          </el-dialog>
          <!-- 统计 -->
          <!-- <el-dialog
            title="统计分析"
            width="1120px"
            :visible.sync="dialogStatisticsVisible"
            :close-on-click-modal="false"
            @close="formClose"
          >
            <el-form :inline="true" :model="msgQueryForm">
              <el-form-item label="手机号" style="margin-right: 10px">
                <el-input
                  style="width: 120px;"
                  v-model="msgQueryForm.mobile"
                  placeholder="手机号码"
                ></el-input>
              </el-form-item>
              <el-form-item label="状态" style="margin-right: 10px">
                <el-select
                  style="width: 140px;"
                  v-model="msgQueryForm.status"
                  placeholder="类型"
                >
                  <el-option
                    v-for="(item, index) in types"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="接收状态"
                v-if="isReport"
                style="margin-right: 10px"
              >
                <el-select
                  style="width: 100px;"
                  v-model="msgQueryForm.report"
                  placeholder="接收状态"
                >
                  <el-option
                    v-for="(item, index) in reports"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发送时间" style="margin-right: 10px">
                <el-date-picker
                  clearable
                  v-model="tempTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  style="width: 370px;"
                  size="small"
                  class="picker"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="msgData" style="width: 100%" v-loading="tableLoading">
              <el-table-column
                align="center"
                prop="mobile"
                label="手机号"
                width="120"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="sendTime"
                label="发送时间"
                width="160"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="smsNumber"
                label="扣费条数"
                width="80"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="statusDesc"
                label="状态"
                width="130"
              >
              </el-table-column>
              <el-table-column
                v-if="isReport"
                align="center"
                prop="report"
                label="接收状态"
                width="80"
              >
              </el-table-column>
              <el-table-column align="content" prop="content" label="发送内容">
              </el-table-column>
            </el-table>
            <el-pagination
              background
              style="text-align:right"
              small
              layout="total, prev, pager, next"
              :page-size="msgQueryForm.pageSize"
              :current-page.sync="msgQueryForm.pageNum"
              :total="msgQueryForm.recordCount"
              @current-change="msgCurrentChange"
            >
            </el-pagination>
          </el-dialog> -->
        </div>
      </div>
    </div>
    <!-- 效果分析新版页面 -->
    <effect-analysis-x v-if="showEffectAnalysisX" :officialObj="officialObj" @onClose="goBackHomeX">
    </effect-analysis-x>
    <!-- 模板弹窗 -->
    <TemplateDialog v-if="dialogTemplateVisible" :dialogTemplateVisible="dialogTemplateVisible" :isGoto="true"
      @close="dialogTemplateVisible = false" />
    <!-- 置顶数量限制 -->
    <el-dialog title="提示" width="650px" :visible.sync="limitNumDialog">
      <div>
        <span></span>
      </div>
      <div class="footer">
        <button class="confirm" @click="isAdvanced = false" style="margin: 10px auto 0">
          确定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import smsRecordForm from "./smsRecordForm";
import effectMarketForm from "./effectMarketForm";
import effectAnalysisX from "../../components/effect-analysis-x.vue";
import TemplateDialog from "@/components/template-dialog.vue";
import {
  getIntelligentList,
  updateIntelligent,
  getAllTemplateList,
  delCustomizeT,
  addSmartMarketing,
  saveTemplate,
  delSmartMarketing,
  stopSmartMarketing,
  copySmartMarketing,
  topSort,
  topSortNum,
  activityStart,
  suspendActivity,
} from "@/api/intelligentMarket/index";
import JdButton from "../../components/common/jd-button.vue";
export default {
  name: "",
  components: {
    smsRecordForm,
    effectMarketForm,
    effectAnalysisX,
    TemplateDialog,
    JdButton,
  },
  data() {
    return {
      showTop: true,
      //置顶弹框
      limitNumDialog: false,
      //分页栏
      queryForm: {
        current: 1,
        size: 10,
        webActivityStatus: "", // 0.设计中， 1.执行中， 2.已结束
        activityName: "",
        total: 0,
        createTimeStart: "",
        createTimeEnd: "",
        executionType: "",
      },
      dialogTemplateVisible: false,
      //新建活动
      isShowAll: false, // 是否显示全部
      officialObj: {},
      showEffectAnalysisX: false, // 新版效果分析
      dialogCampaignVisible: false,
      tempLoading: false,
      formLabelWidth: "80px",
      templateList: [],
      formCampaign: {
        activityName: "",
        templateType: "",
        templateId: "",
      },
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      rulest: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      changeIndex: "", //用于标示变化中的数据下标
      //活动名称修改
      dialogFormVisible: false,
      formName: {
        smartMarketingId: "",
        templateId: "",
        activityName: "",
      },
      //中部切换栏
      activeName: "first",
      //表格内容activeStatus
      tableData: [],
      statuss: [
        { label: "全部", value: "" },
        { label: "设计中", value: "0" },
        { label: "测试执行中", value: "3" },
        { label: "测试执行完成", value: "4" },
        { label: "等待执行", value: "5,6" },
        { label: "执行中", value: "1" },
        { label: "已停止", value: "8" },
        { label: "已结束", value: "2" },
        { label: "执行异常", value: "7" },
        { label: "暂停", value: "9" },
      ],
      activeStatus: "-1",
      tableLoading: false,
      tabIndex: 1, // 1.智能营销 2.短信记录 3.营销效果
      formData: {
        activityName: "",
      },
      dialogTemplateFormVisible: false,
      saveTemplateLoading: false,
      formTemplate: {
        intelligentMarketingId: "",
        name: "",
      },
      itemStateType: "", // 活动模板的id
      recommondList: [], // 推荐模板列表
      searchform: {},
    };
  },
  created() {
    // 埋点
    this.buriedPoint(8, "进入智能营销", "", "", "1");
    setTimeout(() => {
      this.buriedPoint(1, "智能营销", "客户营销", "精准营销");
    }, 500);
  },
  mounted() {
    this.queryList();
    this.getSysAllTemplate();
    //效果分析新tab页
    if (
      this.$route.query.outerId &&
      this.$route.query.source &&
      this.$route.query.sendTime
    ) {
      this.handleSwitch(3);
      if (this.$route.query.smsType) {
        this.officialObj = {
          outerId: this.$route.query.outerId,
          source: this.$route.query.source,
          sendTime: this.$route.query.sendTime,
          smsType: this.$route.query.smsType,
        };
      } else {
        this.officialObj = {
          outerId: this.$route.query.outerId,
          source: this.$route.query.source,
          sendTime: this.$route.query.sendTime,
        };
      }
      console.log(this.officialObj);
      this.showEffectAnalysisX = true;

      // this.handeleEffect(JSON.parse(obj));
    }

    //行业跳过来
    if (this.$route.query.industry) {
      this.handleSwitch(3);
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    // 动态计算是否包含有置顶的
    getBtnWidth() {
      let setWidth = false;
      this.tableData.map((item) => {
        if (item.topSort > 0) {
          setWidth = true;
        }
      });
      return setWidth;
    },
  },
  filters: {
    showExecution(val) {
      var list = ["立即执行", "定时执行", "周期执行"];
      return list[val];
    },
    showStatus(val) {
      var res = "";
      if (val === 0) {
        res = "设计中";
      } else if (val === 1) {
        res = "执行中";
      } else if (val === 2) {
        res = "已结束";
      } else if (val === 3) {
        res = "测试执行中";
      } else if (val === 4) {
        res = "测试执行完成";
      } else if (val === 5 || val === 6) {
        res = "等待执行";
      } else if (val === 7) {
        res = "执行异常";
      } else if (val === 8) {
        res = "已停止";
      } else if (val === 9) {
        res = "暂停";
      }
      return res;
    },
  },
  methods: {
    // 暂停
    handleSuspend(index, row) {
      this.$confirm("您确定要暂停活动吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          suspendActivity(row.id).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.message);
              this.queryList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 启动
    handleStartUp(index, row) {
      this.$confirm("您确定要启动活动吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          activityStart(row.id).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.message);
              this.queryList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 置顶，取消置顶
    handleView1(e, v) {
      let params = {
        type: e,
        id: v.id,
      };
      //置顶数量
      topSortNum().then((res) => {
        if (res.data == 9 && e == 1) {
          this.$confirm(
            "当前置顶活动数量已达<span style='color:red'>9</span>/10，<span style='margin-left:-10px'>是否要继续置顶该活动？</span>",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "limit",
              dangerouslyUseHTMLString: true, // 使用HTML片段
              type: "warning",
            }
          )
            .then(() => {
              topSort(params).then((res) => {
                this.queryList();
                if (e == 0) {
                  this.$message.success("取消置顶成功!");
                } else {
                  this.$message.success("置顶成功!");
                }
              });
            })
            .catch(() => {
              this.$message.info("已取消置顶");
            });
        } else {
          topSort(params).then((res) => {
            this.queryList();
            this.showTop = true;
            if (e == 0) {
              this.$message.success("取消置顶成功!");
            } else {
              this.$message.success("置顶成功!");
            }
          });
        }
      });
    },
    // 创建活动模板
    createActivity() {
      let date = new Date().toLocaleString().replace(/\//g, "-");
      let activityName = "智能营销 " + date.slice(5);
      let _this = this;
      let params = {
        activityName,
        templateType: "",
        templateId: "",
      };

      addSmartMarketing(params).then((response) => {
        if (response.code === 1) {
          console.log("response------>", response);
          let routeUrl = this.$router.resolve({
            name: "miDetal",
            query: {
              id: response.data,
              actName: activityName,
              statusNum: 0,
              type: "Edit",
              clern: "1",
            },
          });
          window.open(routeUrl.href, "_blank");
        } else {
          console.log(response);
          if (response.data) {
            _this.$message.error(response.data.message);
          } else {
            _this.$message.error(response.message);
          }
        }
      });
    },
    getSysAllTemplate() {
      // 获取系统模板
      var param = {
        templateType: 1,
      };
      getAllTemplateList(param).then((res) => {
        this.recommondList = res.data;
      });
    },
    goBackHomeX(val) {
      this.showEffectAnalysisX = false;
    },
    showEffectX(val) {
      // this.showEffectAnalysisX = true,
      this.officialObj = val;
    },
    // 查询表格数据
    queryList(val) {
      let that = this;
      topSortNum().then((res) => {
        if (res.data >= 10) {
          this.showTop = false;
        }
      });
      // let obj = {
      //   activityName: that.queryForm.activityName,
      //   current: that.queryForm.current,
      //   size: that.queryForm.size,
      //   webActivityStatus: that.queryForm.webActivityStatus,
      // };
      this.tableLoading = true;
      getIntelligentList(that.queryForm).then((res) => {
        this.tableLoading = false;
        if (res.code == "1") {
          this.tableData = res.data.records;
          this.queryForm.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 保存模板
    saveAsTemplate() {
      this.$refs.formTemplate.validate((valid) => {
        if (valid) {
          this.saveTemplateLoading = true;
          saveTemplate(this.$data.formTemplate).then((response) => {
            this.saveTemplateLoading = false;
            if (response.code === 1) {
              this.$message.success("模板添加成功");
              this.$data.dialogTemplateFormVisible = false;
              this.$data.formTemplate.name = "";
            }
          });
        } else {
          return false;
        }
      });
    },

    //新建活动
    newFormClose() {
      //表单重置
      this.$refs.formCampaign.resetFields();
      this.$data.formCampaign = {
        activityName: "",
        templateType: "",
        type: "",
        templateId: "",
      };
      this.$data.templateList = [];
    },
    //自定义模板删除
    deleteItem(i, id) {
      delCustomizeT(id).then((res) => {
        if (res.code === 1) {
          this.$message.success("删除成功！");
          this.$data.templateList.splice(i, 1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //添加列表模板类型变化
    typeTemplateChange(value) {
      if (value != "") {
        this.$data.formCampaign.templateId = "";
        this.$data.tempLoading = true;
        var param = {
          templateType: this.$data.formCampaign.templateType,
        };
        getAllTemplateList(param).then((res) => {
          this.$data.templateList = res.data;
          this.$data.tempLoading = false;
        });
      } else {
        this.$data.formCampaign.templateId = "";
        this.$data.templateList = [];
      }
    },
    //选择模板
    selectTemplate(val) {
      //触发视图更新，且能新增属性
      this.$set(
        this.$data,
        "templateList",
        this.$data.templateList.map((item, i) => {
          if (i === val) {
            item.selected = true;
            this.$data.formCampaign.templateId = item.id;
          } else {
            item.selected = false;
          }
          return item;
        })
      );
    },
    //添加列表数据
    addCampaign() {
      this.$refs.formCampaign.validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.$data.formCampaign));
          if (data.templateType !== "" && data.templateId === "") {
            this.$message.error("请选择活动模板！");
            return false;
          }
          //开始-------暂时跳转，后边删除
          // let routeUrl = this.$router.resolve({
          //   name: "miDetal",
          //   query: { id: 11111, type: "Edit" },
          // });
          // window.open(routeUrl.href, "_blank");
          //结束-------
          this.dialogCampaignVisible = false;
          // delete data.type;
          addSmartMarketing(data).then((response) => {
            if (response.code === 1) {
              let activityName = data.activityName;
              let routeUrl = this.$router.resolve({
                name: "miDetal",
                query: {
                  id: response.data,
                  actName: activityName,
                  type: "Edit",
                  statusNum: 0,
                },
              });
              this.dialogCampaignVisible = false;
              window.open(routeUrl.href, "_blank");
            }
          });
        } else {
          return false;
        }
      });
    },
    statusChange() {
      var list = ["", "0", "1", "2"];
      var index = +this.activeStatus + 1;
      this.queryForm.webActivityStatus = list[index];
      this.queryList();
    },
    handleClick(tab, event) {
      // console.log(tab);
      var list = ["", "0", "1", "2"];
      var index = +this.activeStatus + 1;
      this.queryForm.webActivityStatus = list[index];
      this.queryList();
    },
    handleSwitch(index) {
      //清空自带条件
      this.searchform = {};
      this.tabIndex = index;
    },
    newBtn(index) {
      this.dialogCampaignVisible = true;
      if (index !== null && index !== undefined) {
        this.formCampaign.templateType = 1;
        this.$data.templateList = this.recommondList;
        this.selectTemplate(index);
      }
    },
    handleSearch() {
      this.queryForm.current = 1;
      this.queryList();
    },
    //表格修改名称-行
    handleName(index, row) {
      this.formName.id = row.id;
      this.formName.activityName = row.activityName;
      this.changeIndex = index;
      this.dialogFormVisible = true;
    },
    //表格修改名称-行-确认
    updateName() {
      this.$refs.formName.validate((valid) => {
        this.$data.dialogFormVisible = false;
        if (valid) {
          updateIntelligent(this.$data.formName).then((response) => {
            if (response.code === 1) {
              this.$message.success("修改成功！");
              this.$data.tableData[this.$data.changeIndex].activityName =
                this.$data.formName.activityName;
              this.$data.dialogFormVisible = false;
              this.$refs.formName.resetFields();
            }
          });
        } else {
          return false;
        }
      });
    },
    //查看
    handleView(index, row) {
      let routeUrl = this.$router.resolve({
        name: "miDetal",
        query: {
          id: row.id,
          actName: row.activityName,
          type: "Edit",
          status: row.activityStatus,
          statusNum: row.activityStatus,
          executionType: row.executionType,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    //另存
    handleSaveAs(index, row) {
      this.$data.formTemplate.intelligentMarketingId = row.id;
      this.$data.dialogTemplateFormVisible = true;
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSmartMarketing(row.id).then((res) => {
            if (res.code === 1) {
              this.$message.success("删除成功");
              this.queryList(); // 重新查询表格
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //复制活动
    handleCopy(index, row) {
      copySmartMarketing(row.id).then((res) => {
        if (res.code === 1) {
          this.$message.success("复制成功");
          this.queryList(); // 重新查询表格
          let routeUrl = this.$router.resolve({
            name: "miDetal",
            query: {
              id: res.data.id,
              actName: res.data.activityName,
              type: "Edit",
              status: res.data.activityStatus,
              statusNum: res.data.activityStatus,
              executionType: res.data.executionType,
              form: "copy",
            },
          });
          window.open(routeUrl.href, "_blank");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //终止活动
    handleStop(index, row) {
      this.$confirm(
        "您确定要终止活动吗?终止活动后活动将不再继续执行！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "stopTips",
          type: "warning",
        }
      )
        .then(() => {
          stopSmartMarketing(row.id).then((res) => {
            if (res.code === 1) {
              this.$message.success("终止成功");
              this.queryList(); // 重新查询表格
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已终止",
          });
        });
    },
    // 跳转
    toTab(index, row, tab) {
      this.tabIndex = tab;
      this.searchform = row;
    },
    //分页
    queryCurrentChange(val) {
      this.queryForm.current = val;
      this.queryList();
    },
    //重置
    resetForm() {
      this.queryForm = {
        current: 1,
        size: 10,
        activityName: "",
        total: 0,
        createTimeStart: "",
        createTimeEnd: "",
        webActivityStatus: "",
        executionType: "",
      };
      this.queryList();
    },
    clearTime1() {
      this.queryForm.createTimeStart = "";
      this.queryForm.createTimeEnd = "";
    },
  },
};
</script>
<style scoped lang="scss">
/* 添加全局样式 */
/deep/ .el-dropdown-menu__item {
  text-align: center;
}





/deep/ .el-tabs__header::after {
  // display: none;
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #e4e7ed;
  z-index: 1;
  background-color: #e4e7ed;
  height: 1px;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-dialog__body {
  padding-bottom: 0;
}

/deep/ .el-tabs__item {
  padding: 0 16px;
}

.recom-template {
  margin: 20px 28px 0 28px;

  .recom-title {
    background-color: #fafafa;
    height: 32px;
    line-height: 32px;
    padding-right: 12px;

    .divison {
      vertical-align: middle;
      border-radius: 3px;
      width: 3px;
      height: 14px;
      background-color: #fe4d45;
      display: inline-block;
      margin: auto 4px auto 12px;
    }

    .name {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #333;
    }

    .open {
      color: #7f85e9;
      font-size: 12px;
      font-weight: 400px;
      float: right;
      cursor: pointer;
    }
  }

  .recom-list {
    overflow: hidden;
    color: #333;

    .recom-item {
      border: 1px solid #eeeeee;
      border-radius: 4px;
      display: inline-block;
      width: 320px;
      margin-right: 7px;
      margin-top: 12px;

      &:hover {
        border: 1px solid rgba(254, 77, 69, 0.5019607843137255);
      }

      .recom-content {
        height: 113px;
      }

      .img-wrap {
        display: inline-block;
        margin: 17px 12px 0 20px;

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      .text-info {
        display: inline-block;
        padding-top: 17px;
        vertical-align: top;

        .title {
          font-size: 16px;
          font-weight: 500;
          padding-bottom: 6px;
        }

        .info {
          font-size: 13px;
          color: #666;
          width: 217px;
          text-overflow: ellipsis;
          line-height: 18px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }

      .create-btn {
        cursor: pointer;
        text-align: center;
        line-height: 44px;
        font-size: 14px;
        color: #666;
        border-top: 1px solid #eee;
        transition: background-color 0.2s;
        background-color: #fff;

        &:hover {
          background-color: #fe4d45;
          border-radius: 0px 0px 4px 4px;
          color: #fff;
        }
      }
    }
  }
}

/deep/.el-tabs__nav-wrap {
  width: 275px;
}

.intelligentBox {
  margin: 11px 20px;
  min-width: 1130px;

  .tab-line {
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;

    .tab-item {
      text-align: center;
      width: 106px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;

      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }

      &.active {
        border-top: 2px;

        span {
          display: block;
          background: #fff;
        }
      }
    }
  }

  .tab_item_box {
    padding: 0px 27px 20px;

    .status_btn {
      font-size: 14px;
      width: 98px;
      font-size: 14px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;

      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }

    .status_btn2 {
      margin-left: 8px;
      color: #666666;
      font-size: 14px;
      border: 1px solid #dddddd;
      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .search_item {
      display: inline-block;
      margin-right: 79px;
      margin-bottom: 16px;
      color: #333;
    }
  }

  .tab_item_box_one {
    padding: 0px 27px 10px 28px;
  }

  .create_btn3 {
    width: 98px;
    height: 32px;
    opacity: 1;
    border-radius: 3px;
    display: inline-block;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    color: #ffffff;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }

  .right_allBtn {
    float: right;
    color: #333;
    font-size: 14px;
  }

  .table-center {
    margin: 2px 28px 10px 28px;
    padding-bottom: 20px;
  }

  .el-icon-edit-outline {
    cursor: pointer;
  }

  .table-header__bg {
    background-color: #fafafa;

    & th {
      background-color: transparent;
    }
  }
}

.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}

.templist {
  border: 1px solid #e6e6e6;

  border-right: none;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    // box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
  }

  &::-webkit-scrollbar-thumb {
    min-height: 20px;
    background-clip: content-box;
    box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  .titem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 15px;
    border-bottom: 1px solid #ebeef5;

    &.active,
    &.active:hover {

      // background-color: #256FFA;
      span {
        color: #fff;
      }

      .el-button--text {
        color: #fff;
      }
    }

    &:hover {
      background-color: #f5f7fa;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.operation {
  cursor: pointer;
  color: #7f85e9;

  &:hover {
    color: #fe4d45;
  }
}

/** 表单搜索  */
.search-box {
  margin-top: 20px;
  padding-bottom: 20px;

  .el_btn {
    text-align: center;

    .search {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;

      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }

    .reset {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }

  .el-input,
  .el-select {
    width: 280px;
  }

  .my_select_time {
    display: flex;
    align-items: center;
  }
}

.btnGroup {
  display: flex;
  justify-content: left;
  align-items: center;

  .btnText {
    cursor: pointer;
    margin-right: 12px;
  }

}





.btnGroup-width>.jd-button-box:first-child {
  width: 56px;
}
</style>
<style lang="scss">
.stopTips .el-message-box__content {
  padding-left: 20px !important;
  padding: 20px 0 !important;
  text-align: left !important;
  margin-left: 20px;
}

.limit {
  .el-message-box__message p {
    width: 188px !important;
  }
}
</style>
